<template lang="pug">
  el-row(:span="24")
    el-col(:span="12")
      app-display(
        label="Matrícula:",
        :content="imovel.numeroMatricula || '-'",
      )
    el-col(:span="12")
      app-display(
        label="Livro:",
        :content="imovel.livroMatricula || '-'",
      )
    el-col(:span="12")
      app-display(
        label="Folha:",
        :content="imovel.numeroFolhaMatricula || '-'",
      )
    el-col(:span="12")
      app-display(
        label="Nome do cartório:",
        :content="imovel.nomeCartorio || '-'",
      )
    el-col(:span="12")
      app-display(
        label="Município do cartório:",
        :content="imovel.municipioCartorio.nome || '-'",
      )
</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'

export default {

  components: {
    AppDisplay,
    AppCollapse,
    AppDivider
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    }
  },
  computed: {
    imovel () {
      return this.cadastroOriginal.imovel
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesRegistroImovel.vue